import { px } from "framer-motion";
import Input from "../../../../../../../../components/FormikForm/Input";
import { Title } from "./styles";

interface WaitingListFieldsProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (e: any) => void;
  handleBlur: (e: any) => void;
}

const WaitingListFields = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur
}: WaitingListFieldsProps) => {
  return (
    <>
      <Title>¿A dónde querés redirigirlos?</Title>
      <div style={{ height: 4 }} />
      <p style={{
        margin: '8px 0px',
        fontSize: '14px',
        lineHeight: '17px',
        color: 'rgb(113, 113, 113)',
      }}>Elegí adónde querés enviarlos mientras las inscripciones estén cerradas. Si no agregás una URL, el botón de inscripción quedará bloqueado.</p>
      <div style={{ height: 16 }} />
      <div onClick={(e) => e.stopPropagation()}>
        <Input
          name="waiting_list_external_url"
          error={errors?.waiting_list_external_url}
          touched={touched?.waiting_list_external_url}
          value={values?.waiting_list_external_url || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="https://"
          options={{
            label: "URL externa",
            marginBottom: 0,
          }}
        />
      </div>
      <div style={{ height: 16 }} />
      <div onClick={(e) => e.stopPropagation()}>
        <Input
          name="waiting_list_cta_text"
          error={errors?.waiting_list_cta_text}
          touched={touched?.waiting_list_cta_text}
          value={values?.waiting_list_cta_text || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="EJ: Reservar mi lugar"
          options={{
            label: "Texto del botón",
            marginBottom: 0,
          }}
        />
      </div>
    </>
  );
};

export default WaitingListFields;

